import React, { useEffect, useState } from 'react';
import { useAppearance } from '@fourthwall/appearance';
import { Skeleton } from '@fourthwall/components';
import { BarChart } from '../../../chartsModule/components/BarChart/BarChart';
import { LineChart } from '../../../chartsModule/components/LineChart/LineChart';
import { chartColors } from '../../../chartsModule/consts';
import { AnalyticsChartLegend } from '../AnalyticsChartLegend/AnalyticsChartLegend';
import * as S from './AnalyticsCard.styled';
import { isBarChartType, isBarStatsType, isLineChartType, isStatsType } from './AnalyticsCard.types';
import { AnalyticsCardHeading } from './components/AnalyticsCardHeading/AnalyticsCardHeading';
import { BarStatsTypeAnalyticsCardContent } from './components/BarStatsTypeAnalyticsCardContent/BarStatsTypeAnalyticsCardContent';
import { StatsTypeAnalyticsCardContent } from './components/StatsTypeAnalyticsCardContent/StatsTypeAnalyticsCardContent';
export const AnalyticsCard = (props) => {
    const { appearance: settingsAppearance } = useAppearance();
    const [appearance, setAppearance] = useState('light');
    // TODO: Move appearance detection to the AppearanceProvider
    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => {
            setAppearance(e.matches ? 'dark' : 'light');
        };
        setAppearance(mediaQuery.matches ? 'dark' : 'light');
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);
    useEffect(() => {
        if (settingsAppearance === 'light dark') {
            const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
            setAppearance(mediaQuery.matches ? 'dark' : 'light');
        }
        else {
            setAppearance(settingsAppearance === 'dark' ? 'dark' : 'light');
        }
    }, [settingsAppearance]);
    const getSpecificHeadingProps = () => {
        if (isLineChartType(props)) {
            return { value: props.value };
        }
        if (isBarChartType(props)) {
            return { value: props.value };
        }
        if (isStatsType(props)) {
            return {
                subtitle: props.legend,
                value: props.value,
            };
        }
        return {};
    };
    const renderHeading = () => {
        const commonProps = {
            type: props.type,
            header: props.header,
            reportLink: props.reportLink,
            isDataLoading: props.isDataLoading,
            isDefinitionLoading: props.isDefinitionLoading,
            externalSource: props.externalSource,
            formatValue: props.formatValue,
        };
        return React.createElement(AnalyticsCardHeading, { ...commonProps, ...getSpecificHeadingProps() });
    };
    const renderContent = () => {
        if (isLineChartType(props)) {
            return (React.createElement(LineChart, { data: props.data, isLoading: props.isDataLoading, emptyMessage: props.emptyMessage, xAxisFormatter: props.formatXAxis, yAxisFormatter: props.formatYAxis || props.formatValue, appearance: appearance }));
        }
        if (isBarChartType(props)) {
            return (React.createElement(BarChart, { data: props.data, isLoading: props.isDataLoading, emptyMessage: props.emptyMessage, xAxisFormatter: props.formatXAxis, yAxisFormatter: props.formatYAxis || props.formatValue, appearance: appearance }));
        }
        if (isBarStatsType(props)) {
            return (React.createElement(BarStatsTypeAnalyticsCardContent, { data: props.data, isLoading: props.isDataLoading, emptyMessage: props.emptyMessage, formatValue: props.formatValue }));
        }
        if (isStatsType(props)) {
            return (React.createElement(StatsTypeAnalyticsCardContent, { data: props.data, isLoading: props.isDataLoading, emptyMessage: props.emptyMessage, formatValue: props.formatValue }));
        }
    };
    const renderFooter = () => {
        if (isStatsType(props)) {
            return null;
        }
        if (props.isDefinitionLoading) {
            return React.createElement(Skeleton.Shape, { width: 160, height: 16 });
        }
        if (!props.legend) {
            return null;
        }
        const legendColors = {
            lineChart: [chartColors[appearance].series.primary, chartColors[appearance].series.secondary],
            barChart: [chartColors[appearance].series.primary, chartColors[appearance].series.secondary],
            barStats: ['#0042FF', '#B5B3B0'],
        };
        return (React.createElement(AnalyticsChartLegend, { items: [
                {
                    value: props.legend,
                    color: legendColors[props.type][0],
                },
            ] }));
    };
    return (React.createElement(S.Container, null,
        renderHeading(),
        React.createElement(S.Content, null, renderContent()),
        renderFooter()));
};
